import React from "react"
import { Link } from "react-router-dom"
import { ListItem, ListItemIcon, Typography } from "@mui/material"
import theme from "../../../theme/theme"
import PropTypes from "prop-types"

const MenuItem = ({ item, hasPermission }) => {
    const isDisabled = !hasPermission

    return (
        <ListItem sx={{ display: "flex", gap: 1, p: 0 }}>
            <ListItemIcon sx={{ minWidth: "auto" }}>
                {React.cloneElement(item.icon, {
                    style: {
                        color: isDisabled ? "grey" : theme.palette.icon.main,
                        width: 24,
                        height: 24,
                    },
                })}
            </ListItemIcon>

            <Typography
                component={isDisabled ? "span" : Link}
                to={isDisabled ? undefined : item.to}
                variant="body2"
                sx={{
                    color: isDisabled ? "grey.600" : "common.white",
                    cursor: isDisabled ? "not-allowed" : "pointer",
                    textDecoration: isDisabled ? "none" : "underline",
                    "&:hover": {
                        color: isDisabled ? "grey.600" : "icon.main",
                    },
                }}
            >
                {item.name}
            </Typography>
        </ListItem>
    )
}

MenuItem.propTypes = {
    item: PropTypes.shape({
        icon: PropTypes.element.isRequired,
        name: PropTypes.string.isRequired,
        to: PropTypes.string.isRequired,
        id: PropTypes.string,
    }).isRequired,
    hasPermission: PropTypes.bool.isRequired,
}

export default MenuItem
